/* ============================================================
 * LX Article CTA (R53 / Layer 3 + Layer 2 + tracking)
 * 作成: 2026-06-18 / SKILL v5.50
 * 改訂: 2026-06-19 / VV — refresh() 二重呼び出しガード
 * ----------------------------------------------------------------
 * 役割:
 *   (A) 記事ページ用スティッキー CTA (#lx-article-sticky-cta) の表示制御
 *       - 300px スクロール後に表示
 *       - close で 24h cookie (lx_article_sticky_cta_dismiss=1)
 *       - 既存 R49 sticky-footer の上に重ねる（bottom: 70px）
 *       - 記事末尾大型 CTA (.lx-article-end-cta) が画面内に入ったら自動非表示
 *   (B) Layer 2 中盤 CTA の動的挿入
 *       - <!-- lx-inline-cta --> マーカー or .shopify-article-content 内
 *         H2 が 3 つ以上ある場合、3 つ目の H2 の直前に <aside class="lx-inline-cta-placeholder"></aside>
 *         を挿入し、サーバーサイド render の lx-inline-cta スニペット (data-lx-inline-cta-template) を
 *         移動して表示
 *   (C) tracking (window.gtag / window.fbq)
 *       - [data-lx-cta-track] 属性付きの要素 click を捕捉し、GA event を発火
 *
 * ★ 副作用ゼロ原則:
 *   - 既存 lx-rec-section / lx-compare / lx-related-list / lx-sticky-footer の DOM・JS を一切変更しない
 *   - 失敗時はサイレントに諸める（ユーザーには影響なし）
 *
 * ★ VV 2026-06-19 変更点:
 *   - initSticky に `__lxStickyInit` ガード追加 — refresh() を WP fetch 後に再呼び出ししても
 *     scroll/resize リスナーが重複しないように。
 *   - public API に `injectInline` を追加 — 全初期化なしで Layer 2 だけ再注入したい場合用。
 * ============================================================ */
(function () {
  'use strict';

  if (window.__lxArticleCtaLoaded) return;
  window.__lxArticleCtaLoaded = true;

  var SCROLL_THRESHOLD = 300;
  var COOKIE_NAME = 'lx_article_sticky_cta_dismiss';
  var COOKIE_HOURS = 24;

  // ---- cookie helpers ---------------------------------------------------
  function getCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[-.+*]/g, '\\$&') + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }
  function setCookie(name, val, hours) {
    try {
      var d = new Date();
      d.setTime(d.getTime() + hours * 3600 * 1000);
      document.cookie = name + '=' + encodeURIComponent(val) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    } catch (e) {}
  }

  // ---- tracking ---------------------------------------------------------
  function track(label, extra) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'cta_click', Object.assign({
          event_category: 'article_cta_r53',
          event_label: label
        }, extra || {}));
      }
    } catch (e) {}
    try {
      if (typeof window.fbq === 'function' && label && label.indexOf('add') >= 0) {
        window.fbq('track', 'AddToCart', { content_name: label });
      }
    } catch (e) {}
    try {
      if (typeof window.dataLayer !== 'undefined' && window.dataLayer.push) {
        window.dataLayer.push({ event: 'lx_article_cta', label: label });
      }
    } catch (e) {}
  }

  function bindTracking(root) {
    root = root || document;
    var nodes = root.querySelectorAll('[data-lx-cta-track]');
    for (var i = 0; i < nodes.length; i++) {
      (function (el) {
        if (el.__lxBound) return;
        el.__lxBound = true;
        el.addEventListener('click', function () {
          var lbl = el.getAttribute('data-lx-cta-track') || 'unknown';
          track(lbl);
        }, { passive: true });
      })(nodes[i]);
    }
  }

  // ---- Sticky CTA -------------------------------------------------------
  function initSticky() {
    var el = document.getElementById('lx-article-sticky-cta');
    if (!el) return;
    /* VV 2026-06-19: refresh() による二重呼び出しで scroll/resize リスナーが
       重複してパフォーマンス低下するのを防ぐ。 */
    if (el.__lxStickyInit) return;
    el.__lxStickyInit = true;

    // 24h dismiss
    if (getCookie(COOKIE_NAME) === '1') {
      el.style.display = 'none';
      return;
    }

    var shown = false;
    var endCtaEl = document.querySelector('.lx-article-end-cta');
    var ticking = false;

    function show() {
      if (shown) return;
      shown = true;
      el.hidden = false;
      el.setAttribute('aria-hidden', 'false');
      el.classList.add('is-visible');
      track('sticky_show');
    }
    function hide() {
      if (!shown) return;
      shown = false;
      el.classList.remove('is-visible');
      el.setAttribute('aria-hidden', 'true');
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (y < SCROLL_THRESHOLD) {
          hide();
          return;
        }
        // 末尾 CTA が画面内なら非表示（被り回避）
        if (endCtaEl) {
          var r = endCtaEl.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          if (r.top < vh && r.bottom > 0) {
            hide();
            return;
          }
        }
        show();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // close
    var closeBtn = el.querySelector('[data-lx-cta-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        el.style.display = 'none';
        setCookie(COOKIE_NAME, '1', COOKIE_HOURS);
        track('sticky_dismiss');
      });
    }

    // first check
    setTimeout(onScroll, 50);
  }

  // ---- Mid Inline CTA injector ----------------------------------------
  //   .shopify-article-content 内に H2 が 3 個以上ある場合、3 個目の H2 の直前へ
  //   server-side render された .lx-inline-cta (data-lx-inline-cta="true") を
  //   document.body から（または article body 直下から）移動して挿入する。
  //   既に H2 直前/H3 直前にマウントされていれば何もしない。
  function injectInlineCta() {
    var content = document.querySelector('.shopify-article-content') || document.querySelector('#wp-article-content');
    if (!content) return;
    var inline = document.querySelector('[data-lx-inline-cta="true"]');
    if (!inline) return;
    // 既に content 内にあれば移動不要
    if (content.contains(inline)) return;
    var h2s = content.querySelectorAll('h2');
    if (!h2s || h2s.length < 3) {
      // H2 が少ない記事は H2-1 直後または末尾近くに挿入
      if (h2s && h2s.length >= 1) {
        var target = h2s[h2s.length - 1];
        target.parentNode.insertBefore(inline, target);
        return;
      }
      // H2 すら無い場合は何もしない（DOM に既に置かれた位置のまま）
      return;
    }
    var third = h2s[2];
    third.parentNode.insertBefore(inline, third);
  }

  // ---- bootstrap --------------------------------------------------------
  function init() {
    try { initSticky(); } catch (e) {}
    try { injectInlineCta(); } catch (e) {}
    try { bindTracking(document); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // public API
  window.LXArticleCTA = {
    track: track,
    refresh: init,
    /* VV 2026-06-19: Layer 2 inline CTA だけ再注入したい用途用（WP fetch 完了時など） */
    injectInline: injectInlineCta
  };
})();
